<template>
  <section class="details-edit">
    <h2
      class="title-small"
      style="margin-bottom: 39px"
    >
      {{ $t('details') }}
    </h2>
    <ProductType
      v-if="weSewProducts"
      style="margin-bottom: 49px;"
      :value-interest-list="valueInterestList"
      :options-interest-list="optionsInterestList"
      :hints-interest-list="hintsInterestList"
      @valueInterestListChange="valueInterestList = $event"
    />
    <FabricType
      v-if="weHaveTextile"
      :value-textile-list="valueTextileList"
      :options-textile-list="optionsTextileList"
      :hints-textile-list="hintsTextileList"
      @valueTextileListChange="valueTextileList = $event"
    />
    <ButtonsBottom />
  </section>
</template>

<script>
    import ProductType from '../factory/parts/ProductType.vue'
    import FabricType from '../factory/parts/FabricType.vue'
    import ButtonsBottom from '../ButtonsBottom.vue'
    import { optionsInterestList, optionsTextileList } from '../../api/tags'

    export default {
        name: 'DetailsEdit',
        components: { ButtonsBottom, FabricType, ProductType },
        props: {
            valueInterestListStart: {
                default: () => [],
                type: [Array, Function],
            },
            valueTextileListStart: {
                default: () => [],
                type: [Array, Function],
            },
            weHaveTextile: {
                type: Boolean,
                default: true,
            },
            weSewProducts: {
                type: Boolean,
                default: true,
            },
        },
        data: () => ({
            valueInterestList: [],
            valueTextileList: [],
            optionsInterestList: [],
            optionsTextileList: [],
        }),
        computed: {
            hintsInterestList() {
                return this.optionsInterestList.slice(0, 4)
            },
            hintsTextileList() {
                return this.optionsTextileList.slice(0, 4)
            },
        },
        beforeMount() {
            if (this.valueInterestListStart) {
                this.valueInterestList = this.valueInterestListStart
            }
            if (this.valueTextileListStart) {
                this.valueTextileList = this.valueTextileListStart
            }
        },
        async mounted() {
            [this.optionsInterestList, this.optionsTextileList] = await Promise
                .all([optionsInterestList(), optionsTextileList()])
        },
    }
</script>

<style scoped>

</style>
